// extracted by mini-css-extract-plugin
export default {"UploadDetails":"xH_sVEvph0R0MeG_SJUb","UploadBox":"h_y1jBx0tTqWk1Y6LUU0","UploadList":"XZrdlzfqG7BgimCYteaH","UploadItem":"gWjytIMtxE3MxZuQgGbX","UploadImage":"pqDg1ob24fSWx65c0Fui","UploadImg":"u6VQOH9WBc0rpuIFdUfl","UploadText":"XLSbCkBYAlaVQ5CVtTLp","UploadAnchor":"fwtwg3Mw7f0_qOXiiZUO","UploadButton":"OoSu6ay_7kYmmPDCGG2O","Disabled":"Vl9jPhxLw7YxMkXluHRR","UploadButton__Input":"hH8xrp8YwM8AXj3TjCj6","UploadButton__Icon":"cBRQgmkQcoey2SuHgRlA","bluefill_animate":"aQwBdKEF77GzZaFUYVdK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"UploadDetails\":\"xH_sVEvph0R0MeG_SJUb\",\"UploadBox\":\"h_y1jBx0tTqWk1Y6LUU0\",\"UploadList\":\"XZrdlzfqG7BgimCYteaH\",\"UploadItem\":\"gWjytIMtxE3MxZuQgGbX\",\"UploadImage\":\"pqDg1ob24fSWx65c0Fui\",\"UploadImg\":\"u6VQOH9WBc0rpuIFdUfl\",\"UploadText\":\"XLSbCkBYAlaVQ5CVtTLp\",\"UploadAnchor\":\"fwtwg3Mw7f0_qOXiiZUO\",\"UploadButton\":\"OoSu6ay_7kYmmPDCGG2O\",\"Disabled\":\"Vl9jPhxLw7YxMkXluHRR\",\"UploadButton__Input\":\"hH8xrp8YwM8AXj3TjCj6\",\"UploadButton__Icon\":\"cBRQgmkQcoey2SuHgRlA\",\"bluefill_animate\":\"aQwBdKEF77GzZaFUYVdK\"}";
        // 1779800065404
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  